import { useEffect, useState } from 'react';
import { useIsMobileIframe } from './use-is-mobile-iframe';

export function useGetIframeDimensions() {
  const isIframe = useIsMobileIframe();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (isIframe) {
      const onResize = () => {
        const height = window.innerHeight;
        const width = window.innerWidth;

        setDimensions({ width, height });
      };

      onResize();

      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }
  }, [isIframe]);

  return dimensions;
}
